<div class="select-container">
  <select
    class="select select--height-{{ height }}"
    [disabled]="isDisabled()"
    [ngModel]="selected() ?? ''"
    (ngModelChange)="onSelect($event)"
    (blur)="onBlur()"
    data-test-id="select-dropdown"
  >
    @if (showPlaceholder()) {
    <option [ngValue]="''" disabled>
      {{ placeholder() }}
    </option>
    } @if (options?.length > 0) { @for (option of options; track option) {
    <option [ngValue]="option">
      {{ option }}
    </option>
    } } @else if (optionsObj.length > 0) { @for (option of optionsObj; track
    option.label) {
    <option [ngValue]="optionValue(option.value)">
      {{ option.label }}
    </option>
    } }
  </select>
</div>
